import React from 'react';
import FolderIcon from '@mui/icons-material/Folder';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ListItemIcon, ListItemText, MenuItem, Menu, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { menuBoxStyle, menuItemStyle, menuItemHoverStyle } from './styles';

const MenuItems = ({
  firstMenuRef,
  subMenuRef,
  hoverIdx,
  setHoverIdx,
  subMenuOpen,
  setSubMenuOpen,
  subMenuPos,
  menuPos,
  projects,
  handleAddHistoryToProject,
  historyId,
  setOpen,
  onClose,
  setIsEditing,
  setNewTitle,
  currentTitle,
  handleDeleteClick
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* 1차 메뉴: 프로젝트에 추가 */}
      <div
        ref={firstMenuRef}
        style={{
          ...menuItemStyle,
          ...(hoverIdx === 0 ? menuItemHoverStyle : {}),
          position: 'relative',
          margin: 0,
        }}
        onMouseEnter={() => {
          setHoverIdx(0);
          setSubMenuOpen(true);
        }}
        onMouseLeave={() => {
          setHoverIdx(-1);
          setSubMenuOpen(false);
        }}
      >
        <FolderIcon fontSize="small" sx={{ mr: 1 }} />
        <span style={{ flex: 1 }}>{t('drawer.addToProject')}</span>
        <ChevronRightIcon fontSize="small" sx={{ ml: 1 }} />
        {/* 2차 메뉴 */}
        {subMenuOpen && (
          <ul
            ref={subMenuRef}
            style={{
              ...menuBoxStyle,
              left: subMenuPos.left - menuPos.left,
              top: subMenuPos.top - menuPos.top,
              position: 'absolute',
              minWidth: 180,
              margin: 0,
              padding: 0,
              borderRadius: 8,
              listStyle: 'none',
            }}
            onMouseEnter={() => setSubMenuOpen(true)}
            onMouseLeave={() => setSubMenuOpen(false)}
          >
            {projects.map((proj, idx) => (
              <li
                key={proj.id || proj}
                style={{
                  ...menuItemStyle,
                  ...(hoverIdx === 100 + idx ? menuItemHoverStyle : {}),
                  margin: 0,
                  padding: '8px 16px',
                  border: 'none',
                }}
                onMouseEnter={() => setHoverIdx(100 + idx)}
                onMouseLeave={() => setHoverIdx(-1)}
                onClick={() => {
                  handleAddHistoryToProject(proj.id, historyId);
                  setOpen(false);
                  setSubMenuOpen(false);
                  onClose && onClose();
                }}
              >
                <FolderIcon fontSize="small" sx={{ mr: 1 }} />
                <span style={{ flex: 1 }}>{proj.name || proj}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      
      {/* 1차 메뉴: 이름 바꾸기 */}
      <div
        style={{
          ...menuItemStyle,
          color: '#1976d2',
          ...(hoverIdx === 1 ? menuItemHoverStyle : {}),
          margin: 0,
        }}
        onMouseEnter={() => {
          setHoverIdx(1);
          setSubMenuOpen(false);
        }}
        onMouseLeave={() => setHoverIdx(-1)}
        onClick={e => {
          e.stopPropagation();
          setTimeout(() => {
            setIsEditing(true);
            setNewTitle(currentTitle);
          }, 0);
        }}
      >
        <EditIcon fontSize="small" sx={{ mr: 1 }} />
        {t('drawer.rename')}
      </div>
      
      {/* 1차 메뉴: 히스토리 삭제 */}
      <div
        style={{
          ...menuItemStyle,
          color: 'red',
          ...(hoverIdx === 2 ? menuItemHoverStyle : {}),
          margin: 0,
        }}
        onMouseEnter={() => {
          setHoverIdx(2);
          setSubMenuOpen(false);
        }}
        onMouseLeave={() => setHoverIdx(-1)}
        onClick={e => {
          console.log('히스토리 삭제 클릭', historyId, e);
          e.stopPropagation();
          handleDeleteClick(historyId, e);
          setOpen(false);
          onClose && onClose();
        }}
      >
        <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
        {t('drawer.deleteHistory')}
      </div>
    </>
  );
};

export default MenuItems; 